export const GET_INDUSTRY_QUERY_KEY = 'get-industries-mapped';
